module.exports = __webpack_public_path__ + "img/pic21.71c087ac.jpg";